<script>
  import {faMailBulk, faTrashAlt, faEdit, faMoneyBillAlt} from '@fortawesome/free-solid-svg-icons'
  import { mapActions, mapGetters } from 'vuex'
  import FilterHeader from '../generic/FilterHeader.vue'
  import LookupSelect from '../generic/LookupSelect.vue'
  import ReallyClick from '../generic/ReallyClick.vue'

  const md5 = require('md5')

  export default {
    components: {
      FilterHeader,
      LookupSelect,
      ReallyClick
    },
    data () {
      return {
        iconMail: faMailBulk,
        iconEdit: faEdit,
        iconDelete: faTrashAlt,
        iconToggleInvoiced: faMoneyBillAlt,
      }
    },
    computed: {
      ...mapGetters({
        deletedItem: 'customer/del/deleted',
        error: 'customer/list/error',
        items: 'customer/list/items',
        isLoading: 'customer/list/isLoading'
      })
    },

    created () {
      this.getPage()
    },

    methods: {
      ...mapActions({
        getPage: 'customer/list/default'
      }),
      gravatarUrl(email, size, fallback) {
        if (!email) {
          // FIXME: this is simply ugly as hell.
          // return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAIhSURBVDjLlZPrThNRFIWJicmJz6BWiYbIkYDEG0JbBiitDQgm0PuFXqSAtKXtpE2hNuoPTXwSnwtExd6w0pl2OtPlrphKLSXhx07OZM769qy19wwAGLhM1ddC184+d18QMzoq3lfsD3LZ7Y3XbE5DL6Atzuyilc5Ciyd7IHVfgNcDYTQ2tvDr5crn6uLSvX+Av2Lk36FFpSVENDe3OxDZu8apO5rROJDLo30+Nlvj5RnTlVNAKs1aCVFr7b4BPn6Cls21AWgEQlz2+Dl1h7IdA+i97A/geP65WhbmrnZZ0GIJpr6OqZqYAd5/gJpKox4Mg7pD2YoC2b0/54rJQuJZdm6Izcgma4TW1WZ0h+y8BfbyJMwBmSxkjw+VObNanp5h/adwGhaTXF4NWbLj9gEONyCmUZmd10pGgf1/vwcgOT3tUQE0DdicwIod2EmSbwsKE1P8QoDkcHPJ5YESjgBJkYQpIEZ2KEB51Y6y3ojvY+P8XEDN7uKS0w0ltA7QGCWHCxSWWpwyaCeLy0BkA7UXyyg8fIzDoWHeBaDN4tQdSvAVdU1Aok+nsNTipIEVnkywo/FHatVkBoIhnFisOBoZxcGtQd4B0GYJNZsDSiAEadUBCkstPtN3Avs2Msa+Dt9XfxoFSNYF/Bh9gP0bOqHLAm2WUF1YQskwrVFYPWkf3h1iXwbvqGfFPSGW9Eah8HSS9fuZDnS32f71m8KFY7xs/QZyu6TH2+2+FAAAAABJRU5ErkJggg=='
        }

        let param = []

        if (fallback) {
          param.push('d=' + fallback)
        }

        if (size) {
          param.push('s=' + size)
        }

        return 'https://www.gravatar.com/avatar/' + md5(email || '') + (param.length === 0 ? '' : '?' + param.join('&'))
      }
    }
  }
</script>
<template>
  <b-container fluid>
    <filter-header storeNamespace="customer" :addTo="{ name: 'CustomerCreate' }">
    </filter-header>
    <b-row>
      <b-alert v-if="isLoading" show variant="info" class="col-12">Loading...</b-alert>
      <b-alert v-if="deletedItem" show="5" dismissible variant="success" class="col-12">{{ deletedItem['@id'] }} deleted.</b-alert>
      <b-alert v-if="error" show variant="danger" class="col-12"><font-awesome-icon :icon="iconError"></font-awesome-icon> {{ error }}</b-alert>
    </b-row>

    <b-row>
      <b-col cols="3" v-for="item in items" :key="item['@id']">
        <b-card
          no-body
          header-tag="header"
          class="overflow-hidden"
          >
          <div slot="header" class="row">
            <h6 class="mb-0 col-8">{{item.nr}} - {{item.addr1}}</h6>
            <div class="mb-0 col-4 text-right">
              <b-button size="sm" type="submit" variant="info" :href="'mailto:' + item.email" :disabled="!item.email"><font-awesome-icon :icon="iconMail"></font-awesome-icon></b-button>
              <b-button size="sm" type="submit" variant="success" :title="$t('button.edit')" :to="{name: 'CustomerUpdate', params: { id: item['@id'] }}"><font-awesome-icon :icon="iconEdit"></font-awesome-icon></b-button>
              <really-click
                :title="$t('button.delete')"
                message="customer.messages.delete-confirm"
                @click="deleteRow()"
                class="inline"
                variant="danger"
                size="sm"
              >
                <font-awesome-icon :icon="iconDelete" />
              </really-click>
            </div>
          </div>
          <b-row no-gutters class="mt-2">
            <b-col md="3">
              <b-card-img :src="gravatarUrl(item.email, 160, 'retro')" class="rounded-0"></b-card-img>
            </b-col>
            <b-col md="9">
              <b-card-body :title="item.addr1">
                <b-card-text>
                  {{item.addr2}}<br>
                  {{item.addr3}}<br>
                  {{item.addr4}}<br>
                  {{item.email}}<br>
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

